import React from "react";
import { Box, Modal, Typography } from "@mui/material";
import I18n from "i18next";

import MzButton from "@markaaz/ui/MzButton";
import MzPagination from "@markaaz/ui/MzPagination";
import { trimCharecter } from "../../../utils/helper";
import LoadingOverlay from "components/Common/Overlay/LoadingOverlay";
import ReportHistory from "./ReportHistory";

const sx = {
  header: {
    color: (theme) => theme.palette.darkBlue.c100
  }
};

export default function ReportActivityHistory({
  isOpen,
  reportName,
  historyData = {},
  onClose,
  onHistoryPageChange,
  historyPageNo,
  historyError
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 580,
    bgcolor: "common.white",
    boxShadow: 24,
    padding: "50px",
    borderRadius: "10px",
    color: "darkBlue.c100"
  };
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box sx={style}>
        {!historyData?.details?.length ? (
          <Box display="flex" alignItems="center" justifyContent="center" height="200px">
            {historyError === "Error" ? <Typography variant="body2">No History found</Typography> : <LoadingOverlay />}
          </Box>
        ) : (
          <>
            <Box textAlign="center">
              <Typography variant="h5" sx={sx.header}>
                {trimCharecter(I18n.t("reports.historyOf", { name: reportName }))}
              </Typography>
            </Box>
            <Box paddingY="50px" minHeight="300px">
              <ReportHistory HistoryData={historyData} />
            </Box>
            {historyData?.rec_count > 5 && (
              <Box paddingBottom="55px" justifyContent="center" display="flex">
                <MzPagination
                  onChange={onHistoryPageChange}
                  page={historyPageNo?.PageNo}
                  count={Math.ceil(historyData?.rec_count / 5)}
                />
              </Box>
            )}
            <Box justifyContent="center" display="flex">
              <MzButton variant="contained" color="primary" size="large" onClick={onClose}>
                {I18n.t("common.close")}
              </MzButton>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
}
